import { useContext, createContext } from "react";

export type ManagerState =
  | "Unknown"
  | "Idle"
  | "AssemblingWorld"
  | "LaunchingServer"
  | "Running";

export type ManagerStatus = {
  state: ManagerState;
  worldUuid: string | null;
  ping: () => Promise<void>;
  forget: () => void;
};

export const unknown: () => ManagerStatus = () => ({
  state: "Unknown",
  worldUuid: null,
  ping: async () => {},
  forget: () => {},
});

export const ManagerContext = createContext<ManagerStatus>(unknown());

export const useWorldUuid = () => {
  return useContext(ManagerContext).worldUuid;
};

export const useManagerAvailable = () => {
  return useContext(ManagerContext).state !== "Unknown";
};
